export default "__VITE_ASSET__BTxmvtCr__"